<template>
  <BaseLayout pageTitle="案件">
    <div class="case">
      <div class="f-center p-t-30 p-b-30 segment">
        <div class="segment-box">
          <ion-segment @ionChange="segmentChanged($event)" value="1">
            <ion-segment-button value="1">
              <div class="font-lg">进行中</div>
            </ion-segment-button>
            <ion-segment-button value="2">
              <div class="font-lg">已完结</div>
            </ion-segment-button>
          </ion-segment>
        </div>
      </div>
      <ListItem
        v-for="(item, index) in data"
        :key="index"
        :lawyerName="item.lawyerName"
        :lawyerAvatar="item.lawyerAvatar"
        :lawOffice="item.lawOffice"
        :name="item.name"
        :product="item.product"
        :num="item.num"
        :time="item.time"
        :lawTypeDictEs="item.lawTypeDictEs"
      />
    </div>
  </BaseLayout>
</template>

<script>
import { ref } from 'vue'
import { ListItem } from '@/view/case/components'
import jz1Image from '@/assets/jz/1.png'
import jz2Image from '@/assets/jz/2.png'
import jz3Image from '@/assets/jz/3.png'
import jz4Image from '@/assets/jz/4.png'
import jz5Image from '@/assets/jz/5.png'

export default {
  setup(props, { emit }) {
    const data = ref([
      {
        lawyerName: '云文虹',
        lawyerAvatar: jz1Image,
        lawOffice: '重庆鲲鹏律师事务所',
        name: '龙建与刘必仁、许滇音民间借贷纠纷一案',
        product: '订购的服务产品：民事诉讼一审法律服务产品（原告）',
        num: 'KB-20210001PC2',
        time: '2021.05.21 16:37',
        lawTypeDictEs: '法律关系(案由)：民事法律事务>劳务报酬金融>劳务报酬',
      },
      {
        lawyerName: '戴宇航',
        lawyerAvatar: jz2Image,
        lawOffice: '重庆鲲鹏律师事务所',
        name: '中天建设集团有限公司与重庆美堡建筑工程有限公司票据追索权纠纷一案',
        product: '订购的服务产品：民事诉讼一审法律服务产品（原告）',
        num: 'KB-20210001PC2',
        time: '2021.05.21 16:37',
        lawTypeDictEs: '法律关系(案由)：民事法律事务>劳务报酬金融>劳务报酬',
      },
      {
        lawyerName: '闻芝宇',
        lawyerAvatar: jz3Image,
        lawOffice: '重庆鲲鹏律师事务所',
        name: '中天建设集团有限公司与重庆美堡建筑工程有限公司票据追索权纠纷一案',
        product: '订购的服务产品：民事诉讼一审法律服务产品（原告）',
        num: 'KB-20210001PC2',
        time: '2021.05.21 16:37',
        lawTypeDictEs: '法律关系(案由)：民事法律事务>劳务报酬金融>劳务报酬',
      },
      {
        lawyerName: '林权',
        lawyerAvatar: jz4Image,
        lawOffice: '重庆鲲鹏律师事务所',
        name: '博彦科技（深圳）有限公司与文坚劳动争议二审民事判决书',
        product: '订购的服务产品：民事诉讼一审法律服务产品（原告）',
        num: 'KB-20210001PC2',
        time: '2021.05.21 16:37',
        lawTypeDictEs: '法律关系(案由)：民事法律事务>劳务报酬金融>劳务报酬',
      },
    ])
    const state = ref('1')
    const segmentChanged = (e) => {
      console.log('e.detail.value', e.detail.value)

      state.value = e.detail.value
    }
    return { data, state, segmentChanged }
  },
  components: { ListItem },
}
</script>


<style lang="scss">
.case {
  .segment {
    margin: auto;
    background-color: #f6f7fa;

    .segment-box {
      // width: 540px;
      // border-radius: 34px;
    }
    // ion-segment {
    //   --background: #fff;
    //   border-radius: 40px;
    //   padding: 6px;
    //   height: 86px;
    // }
    ion-segment-button {
      // --indicator-color: #3370ff;
      // --border-radius: 33px;
      // --indicator-height: 66px;
      // --color: #fff;
    }
  }
}
</style>